export default __webpack_public_path__ + "static/lynh-logo-086e35446c273a93f6895c130b853277.jpg";